export const v1_identifier = 'v1'

export const API_URLs = {
  v1: {
    GET_Metadata: '/api/Metadata',
    GET_PeerSupporterValidate: '/api/PeerSupporters/ValidateWithStatus',
    GET_RequestNotification: '/api/Request',
    GET_Request: '/api/Request/',
    POST_Request: '/api/Request',
    PATCH_RequestStatusUpdate: '/api/Request/StatusUpdate',
    PATCH_AvailabilityStatus: '/api/PeerSupporters/AvailableStatusUpdate',
    POST_RequestType: '/api/Request/GetRequestByType',
    GET_Metrics: '/api/GetMetrics',
    POST_BulkUpload: '/api/PeerSupporters/upload',
    GET_ViewRequest: '/api/Request/ViewRequest/',
    POST_GetPeerSupporters: '/api/PeerSupporters/GetPeerSupporters',
    GET_PeerSupporterNotifications: '/api/Request/GetRequestNotifications',
    POST_AddSupporter: '/api/PeerSupporters',
    PATCH_SupporterUpdate: '/api/PeerSupporters/Update',
    GET_Profile: '/api/Profile',
    POST_Profile: '/api/Profile',
    PATCH_Profile: '/api/Profile',
    PATCH_PeerSupporter: '/api/Request/PeerSupporterUpdate',
    POST_PeerSupporterActivity: '/api/PeerActivity',
    POST_GetPeerSupporterList: '/api/PeerSupporters/GetPeerSupportersList',
    PATCH_UnassignRequest: '/api/PeerSupporters/UnassignRequest',
    POST_GetPeerSupporterLeadsList: '/api/PeerSupporterLeads/Get',
    PATCH_DeletePeerSupporterLead: '/api/PeerSupporterLeads/Delete',
    POST_AddAdmin: '/api/PeerSupporterLeads',
    PATCH_DeleteMetadata: '/api/Metadata/Delete',
    POST_CreateMetadata: '/api/Metadata',
    PATCH_EditRequest: '/api/Request/UpdateRequest',
    PATCH_DeleteRequest: '/api/Request/CancelRequest',
    POST_CreateNomination: '/api/PeerSupporterNominations',
    POST_GetPeerSupporterNominations:
      '/api/PeerSupporterNominations/GetPeerSupporterNominations',
    GET_NominationNotifications:
      '/api/PeerSupporterNominations/GetNominationNotifications',
    Get_Viewnomination: '/api/PeerSupporterNominations/ViewNomination/',
    PATCH_NominationStatusUpdate: '/api/PeerSupporterNominations/StatusUpdate',
    PATCH_UpdateName: '/api/Metadata/NameUpdate',
    POST_RequestBulkUpload: '/api/Request/upload',
  },
}
